import type { ObjectMergeExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';
import { merge } from 'lodash-es';

export const objectMergeResolver =
  createSimpleNamedExpressionResolver<ObjectMergeExpression>(
    'objectMerge',
    (a, b) => merge(a, b)
  );
